import loadable from '@loadable/component';

export const ViewUnpublishedOrgPageLoadable = loadable(
  () => import('./ViewUnpublishedOrgPage'),
  { resolveComponent: (module) => module.ViewUnpublishedOrgPage },
);
